import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FieldErrorMessageComponent } from '../field-error-message/field-error-message.component';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'ds-form-field',
  imports: [FieldErrorMessageComponent, NgTemplateOutlet],
  templateUrl: './form-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent {
  public id = input.required<string>();
  public label = input.required<string>();
  public errors = input<ValidationErrors | null | undefined>({});
  public hideLabel = input(false);
  public hintAfter = input<string>();
  public isCheckable = input(false);
  public isInvalid = input(false);
  public readonly = input();
  public required = input(false);

  protected showValidationMessages = computed(() => this.isInvalid() && Object.keys(this.errors() || []).length > 0);
}
